import { FC } from 'react';
import { Page } from 'layouts/Page';
import { PpwrSettings } from 'components/Ppwr/PpwrSettings';

export const PpwrSettingsPage: FC = () => {
	return (
		<Page title="EPR/PPWR Settings – EAS Control Center">
			<PpwrSettings />
		</Page>
	);
};
